//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faArrowCircleDown } from '@fortawesome/pro-light-svg-icons';

export default {
  name: 'BrandKitLogo',
  props: {
    heading: {
      type: String,
      required: true,
    },
    logoUrl: {
      type: String,
      required: true,
    },
    logoUrlDark: {
      type: String,
      default: null,
    },
    logoUrlPng: {
      type: String,
      default: null,
    },
    logoCardClasses: {
      type: String,
      default: '',
    },
    isDownload: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    BaseImg: () => import('@motionelements/core/src/components/ui/BaseImg.vue'),
  },
  data() {
    return {
      faArrowCircleDown,
    };
  },
};
